module.exports = __webpack_public_path__ + "img/icon_order_manager.abc5c323.png";